import { UPDATE_CHANNEL_WHATSAPP_STATUS } from '@/store/mutation-types';

import {
  enterAgentWhatsAppChannel,
  leaveAgentWhatsAppChannel,
} from '@/services/channel-service';
import { getStatusAgentChannels } from '@/services/agent-service';

const actions = {
  setConnectedInWhatsApp({ commit, dispatch }) {
    commit(UPDATE_CHANNEL_WHATSAPP_STATUS, 'available');
    // dispatch('showSnackbar', { text: 'loggedInChannel-whatsapp', type: 'success' }, { root: true })
  },

  setDisconnectedInwhatsApp({ commit, dispatch }) {
    commit(UPDATE_CHANNEL_WHATSAPP_STATUS, 'disconnected');
    dispatch(
      'showSnackbar',
      { text: 'disconnectChannel-whatsapp', type: 'success' },
      { root: true },
    );
  },

  async connectWhatsApp({ commit, dispatch, rootState }, agentId) {
    enterAgentWhatsAppChannel(agentId).catch((err) => {
      const informations = err.response.data;
      if (informations && informations.cause) {
        commit(UPDATE_CHANNEL_WHATSAPP_STATUS, 'disconnected');
        let messageError = 'notAllowWhatsapp';
        switch (informations.cause) {
          case 'online':
            if (rootState.channel.channels.whatsapp.status == 'disconnected') {
              getStatusAgentChannels(agentId)
                .then((status) =>
                  dispatch('channel/updateStatusChannels', status, {
                    root: true,
                  }),
                )
                .catch(console.log);

              return;
            }
            break;
          case 'limit':
            messageError = 'notAllowLoginBecauseLimitWhatsApp';
            break;
          case 'queue':
            messageError = 'notAllowLoginBecauseQueueWhatsApp';
            break;
        }
        if (messageError === 'limit') return;
        dispatch(
          'showSnackbar',
          { text: messageError, type: 'error' },
          { root: true },
        );
      } else {
        dispatch(
          'showSnackbar',
          { text: 'errorConnectChannel', type: 'error' },
          { root: true },
        );
      }
    });
  },

  async disconnectWhatsApp({ dispatch }, agentId) {
    try {
      leaveAgentWhatsAppChannel(agentId).catch(() => {
        dispatch(
          'showSnackbar',
          {
            text: 'errorDisconnectChannel',
            type: 'error',
          },
          { root: true },
        );
      });
    } catch (err) {
      dispatch(
        'showSnackbar',
        { text: 'errorDisconnectChannel', type: 'error' },
        { root: true },
      );
    }
  },
};

export default actions;
